import * as React from 'react';
import { useIntl } from 'react-intl';
import useDocumentTitle from '../../hooks/useDocumentTitle';

export default function AboutPage(): JSX.Element {
  const { formatMessage: f } = useIntl();
  useDocumentTitle(f({ id: 'menu.aboutApp' }));

  const ovalImgUri = new URL('/assets/images/about/oval.png', import.meta.url).href;

  return (
    <div className="col-12" data-cy="about">
      <div className="row section page-head" data-cy="about-head">
        <h4 data-cy="reports-title">O aplikácii</h4>
      </div>
      <div className="row">
        <div className="col-12">
          <h1 style={{ fontSize: '24px', color: '#494949', fontWeight: 400 }}>
            Podmienky používania webovej aplikácie a mobilnej
            <br />
            aplikácie Commander.
          </h1>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2
            style={{
              fontSize: '16px',
              fontWeight: 400,
              background: `url(${ovalImgUri}) left center no-repeat`,
              height: '32px',
              padding: '1rem',
            }}
          >
            Copyright
          </h2>
          <p>
            Webové stránky, aplikácie( webové a mobilné), ich zobrazenia, a všetky informácie
            uvedené na webových stránkach a aplikáciách prevádzkovateľa ako aj všetky texty,
            obrázky, grafické prvky a iné materiály, vrátane web designu, layout zdrojových kódov
            webových stránok prevádzkovateľa, sú chránené autorským právom podľa zákona č. 185/2015
            Z.z. Autorský zákon v platnom znení(ďalej iba ako „Autorský zákon“).
          </p>
        </div>
        <div className="col-md-6 col-12">
          <img
            src={new URL('/assets/images/about/about-1.png', import.meta.url).href}
            alt=""
            width="100%"
            style={{ marginBottom: '80px' }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-12">
          <img
            src={new URL('/assets/images/about/about-2.png', import.meta.url).href}
            alt=""
            width="100%"
            style={{ marginBottom: '80px' }}
          />
        </div>
        <div className="col-md-6 col-12">
          <h2
            style={{
              fontSize: '16px',
              fontWeight: 400,
              background: `url(${ovalImgUri}) left center no-repeat`,
              height: '32px',
              padding: '1rem',
            }}
          >
            Trademarks
          </h2>
          <p>
            Ochranné známky, obchodné mená, logá, znaky, servisné značky a iné označenia (spoločne
            ako “chránené označenia“) zobrazené a používané na webových stránkach sú chráneným
            právom duševného vlastníctva majiteľov týchto označení. Majiteľom autorských práv je
            prevádzkovateľ, autori a/alebo tretie strany, ktoré obsah chránených označení vytvorili
            a/alebo umožnili prevádzkovateľovi jeho používanie.
          </p>
          <p>
            Webové stránky a aplikácie obsahujú aj chránené označenia tretích strán odlišných od
            prevádzkovateľa, ktoré prevádzkovateľ používa a uverejňuje so súhlasom týchto osôb,
            pokiaľ je takýto súhlas potrebný a to len na dohodnutý účel.
          </p>
          <p>
            Všetky tieto chránené označenia tretích strán sú chránené právami týchto tretích strán a
            na ich prehliadanie, používanie či iné nakladanie sa tieto podmienky používania vzťahujú
            v rovnakom rozsahu ako na chránené označenia patriace prevádzkovateľovi. Akékoľvek
            použitie/zneužitie chránených označení zobrazených na webových stránkach, aplikáciách, s
            výnimkou prípadov výslovne stanovených (umožnených) v týchto podmienkach používania, je
            zakázané.
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2
            style={{
              fontSize: '16px',
              fontWeight: 400,
              background: `url(${ovalImgUri}) left center no-repeat`,
              height: '32px',
              padding: '1rem',
            }}
          >
            Privacy Policy
          </h2>
          <p>
            Ochrana osobných údajov, ktoré ste nám zverili je pre nás prioritou a preto chceme, aby
            ste sa ako užívateľ webovej stránky a našich online služieb cítili bezpečne. Je
            dôležité, aby ste boli plne informovaní o údajoch, ktoré spracovaní spracovaní ponúk a
            služieb online, a aby ste boli oboznámení s tým, ako ich používame. Viac sa dočítate na
            našej webovej stránke/ sekcia ochrana osobných údajov,
            <a
              href="https://www.commander.sk/gdpr-a-ochrana-udajov/?preview=true"
              target="_blank"
              rel="noreferrer"
            >
              kliknutím na tento odkaz.
            </a>
          </p>
        </div>
        <div className="col-md-6 col-12">
          <img
            src={new URL('/assets/images/about/about-3.png', import.meta.url).href}
            alt=""
            width="100%"
            style={{ marginBottom: '80px' }}
          />
        </div>
      </div>
    </div>
  );
}
